import React from "react"
import styled from "styled-components"
import { DIFFICULTY_RATINGS_OBJECT } from "@src/utils/constants/difficulty-ratings"

const Title = styled.h1`
  color: ${props => props.theme.blackShade};
  font-size: 46px;
  font-style: normal;
  font-weight: 800;
  line-height: 64px;
  letter-spacing: 0.5px;
  margin-bottom: 29px;
  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 44px;
    margin-bottom: 15px;
  }
`

const Card = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  max-width: 600px;

  @media (max-width: 380px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`

const Image = styled.img`
  width: 115px;
  height: 92px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 23px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
`

const TourTitle = styled.h2`
  color: ${props => props.theme.blackShade};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0.055px;
  margin: 0;
  margin-bottom: 8px;

  @media (max-width: 500px) {
    font-size: 18px;
    line-height: 24px;
  }
`

const Meta = styled.p`
  color: ${props => props.theme.blackShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 0;
  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 16px;
  }
`

function CreateQuoteHero({ heroImage, category, difficulty, title, nights }) {
  return (
    <div>
      <Title>Create a quote</Title>
      <Card>
        <Image {...heroImage} />
        <Content>
          <TourTitle>{title}</TourTitle>
          <Meta>
            {nights + 1} days • {category} •{" "}
            {`${DIFFICULTY_RATINGS_OBJECT[difficulty].title} (${difficulty}/5)`}
          </Meta>
        </Content>
      </Card>
    </div>
  )
}

export default CreateQuoteHero
